<template>
    <div>
        <!--middle middle section-->
        <div class="main-internal-section width-full float-l">
            <div class="container">
                <template v-if="cantAccessPage === true">
                    <div class="row">

                        <div class="chat-btm-section-main add-user-main-section width-full float-l"> <!--middle section-->

                            <div class="web-add-form float-l width-full">
                                <h2 class="chat-page-title float-l colpie-80 color-333333 heading-text-18 line-height-22 font-bold ucase"> {{headerText}} </h2>
                                <div class="add-user-form width-full float-l mt_10 ">              
                                    <div class="top-label-section float-l width-full"> <!--top section-->

                                        <div class="form-group float-l width-full p_15">
                                            <p class="select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"> Dayforce ID </p>
                                            <input type="text" :disabled="isUpdate" class="form-control custom-select" v-model="emp_id" name="Employee Id" id="emp_id" placeholder="Type Dayforce ID">
                                            <div class="help is-danger">{{emp_error_msg}}</div>
                                        </div>

                                        <div class="register-btn dayforce-id-btn float-l col-12" v-if="!isUpdate">
                                            <button type="submit" class="btn btn-primary internal-large-btn float-l mr_20" v-on:click="getUserDetails()">
                                                <span class="gradient"></span>Get User Detail
                                            </button>
                                        </div>
                                        
                                        <div class="form-group float-l width-full p_15">
                                            <p class="select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"> Name </p>
                                            <input type="text" :disabled="isUpdate" v-validate="'required'" class="form-control custom-select" v-model="name" name="Name" id="name" placeholder="Type your name">
                                            <span v-show="errors.has('Name')" class="help is-danger">{{ errors.first('Name') }}</span>
                                        </div>

                                        <!-- <p v-if="isUpdate" class="change-password float-r right width-full pr_15 mb_0">
                                            <a href="javascript:void(0)" data-toggle="modal" data-target="#password" class="color-f5911e font-benton-bold heading-text-14 line-height-16"> Change Password
                                            </a>
                                        </p> -->
                                        
                                        <div class="form-group float-l width-full p_15">
                                            <p class="select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"> Email address </p>
                                            <input type="text" :disabled="isUpdate" v-validate="'required|email'" class="form-control custom-select" v-model="email" name="E-mail" id="email" placeholder="Type your email">
                                            <span v-show="errors.has('E-mail')" class="help is-danger">{{ errors.first('E-mail') }}</span>
                                        </div>

                                        <div class="form-group float-l width-full p_15" v-if="!isUpdate">
                                            <p class="select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"> Password </p>
                                            <input :type="pType" v-validate="'required|min:6'" class="form-control custom-select" v-model="password" name="Password" id="pwd" placeholder="Type your passowrd" ref="Password">
                                            <span v-show="errors.has('Password')" class="help is-danger">{{ errors.first('Password') }}</span>
                                            <a href="javascript:void(0)" v-on:click="hideShow(this)"> <span> <i class="fa fa-eye"></i> </span></a>
                                        </div>

                                        <div class="form-group float-l width-full p_15" v-if="!isUpdate">
                                            <p class="select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"> Confirm Password </p>
                                            <input :type="cType" v-validate="'required|confirmed:Password'" class="form-control custom-select" v-model="cpassword" name="Confirm Password" id="cpwd" placeholder="Confirm your passowrd">
                                            <span v-show="errors.has('Confirm Password')" class="help is-danger">{{ errors.first('Confirm Password') }}</span>
                                            <a href="javascript:void(0)" v-on:click="hideShowCPass(this)"> <span> <i class="fa fa-eye"></i> </span></a>
                                        </div>
                                    </div> <!--top section-->

                                    <div class="btm-label-section float-l width-full bgcolor-f5f5f5"> <!--bottom section-->
                                        <div class="form-group float-l width-full p_15">
                                            <p class="select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"> Timezone </p>

                                            <v-select v-model="timezoneId" :clearable=false name="timezoneId" placeholder="Select Timezone."
                                                    label="text"
                                                    :options="timezoneArr">
                                            </v-select>
                                            <!-- <span> <i class="fa fa-angle-down"></i> </span> -->
                                        </div>

                                        <div class="add-user-role-add-title float-l width-full">
                                            <p class="color-333333 heading-text-16 line-height-18 font-benton-bold ucase mt_20 float-l colpie-70"> Section / Role </p>

                                            <button type="submit" v-on:click.prevent="addLine(this)" class="btn btn-primary internal-large-btn internal-large-btn-blue float-l colpie-30 mt_15 float-r">
                                                <span class="gradient"></span>  Add
                                            </button>
                                        </div>

                                        <div class="role-internal-section float-l width-full"> <!--Internal section-->
                                            <template v-for="(section, index) in generateSectionArr">
                                                <div class="role-add-section float-l width-full" v-bind:key="index">

                                                    <div class="section-role-title-section float-l width-full">
                                                        <h3> Add {{index + 1}} </h3>
                                                        <template>
                                                            <a href="" class="fa fa-times fa-2 close-section" v-on:click.prevent="removeLine(index, section.sectionId, section.roleId)"></a>
                                                        </template>
                                                    </div>

                                                    <!-- <label>&nbsp;&nbsp;</label> -->
                                                    <template>
                                                        <!-- <button type="submit" v-if="index + 1 === generateSectionArr.length" v-on:click.prevent="addLine($event, index)" class="btn btn-primary internal-large-btn internal-large-btn-blue float-l colpie-30 mt_15 float-r">
                                                            <span class="gradient"></span>  Add
                                                        </button> -->
                                                        <!-- <a href="" class="fa fa-plus fa-2" v-if="index + 1 === generateSectionArr.length" v-on:click.prevent="addLine($event, index)"></a> -->
                                                    </template>
                                                    
                                                    <div class="form-group float-l width-full p_15">
                                                        <p class="select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"> Section </p>
                                                        <v-select 
                                                            v-model="section.sectionId" 
                                                            :clearable=false 
                                                            name="sectionId" 
                                                            placeholder="Select Section."
                                                            label="text"
                                                            :options="sectionArr"
                                                        >
                                                        </v-select>
                                                        <div class="help is-danger">{{section.section_error_msg}}</div>
                                                    </div>

                                                    <div class="form-group float-l width-full p_15">
                                                        <p class="select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"> Role </p>
                                                        <v-select v-model="section.roleId" :clearable=false name="roleId" placeholder="Select Role."
                                                            label="text"
                                                            :options="roleArr">
                                                        </v-select>
                                                        <div class="help is-danger">{{section.role_error_msg}}</div>
                                                    </div>                                                                                               
                                                </div>
                                            </template>
                                        </div> <!--Internal section-->

                                        <div class="register-btn float-l col-12">
                                            <button id="" type="submit" class="btn btn-primary internal-large-btn float-l mr_20" v-on:click="createUser()">
                                                <span class="gradient"></span>   {{btnText}}
                                            </button>

                                            <button type="submit" class="btn btn-primary internal-large-btn internal-small-btn float-l" v-on:click="backToUser()">
                                                <span class="gradient"></span>  Back
                                            </button>
                                        </div>

                                    </div> <!--bottom section-->
                                </div>
                            </div> 
                        </div> <!--middle section-->	
                    </div>
                    <div class="modal fade forward-chat-modal email-chat-modal" id="password" tabindex="-1" role="dialog" aria-labelledby="password" aria-hidden="true"> <!--Change Password modal popup--> 

                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    <h4 class="modal-title" id="myModalLabel">Change Password</h4>
                                </div>

                                <div class="modal-body email-chat-main float-l width-full p_0">
                                    <div class="form-group float-l width-full p_15">
                                        <input type="password" v-model="changePassword" name="email" placeholder="Enter your Password" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Enter your Password'" class="form-control custom-select">
                                        <div class="help is-danger">{{chagne_pwd_error_msg}}</div>
                                    </div>

                                    <div class="form-group float-l width-full p_15">
                                        <input type="password" v-model="changeCPassword" name="email" placeholder="Confirm your Password" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Confirm your Password'" class="form-control custom-select">
                                        <div class="help is-danger">{{chagne_cpwd_error_msg}}</div>
                                    </div>
                                </div>

                                <div class="chat-forward-btm float-l width-full relative pl_15 pr_15">                                
                                    <button type="update" class="btn btn-primary internal-large-btn float-l mr_20" v-on:click="chagnePasswrodAPI()">
                                        <span class="gradient"></span> Send
                                    </button>

                                    <button type="submit" class="btn btn-primary internal-large-btn internal-small-btn float-l" v-on:click="changePasswordModalClose()">
                                        <span class="gradient"></span>  Cancel
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div> <!--Change Password modal popup-->
                </template>
                <template v-else>
                    <template v-if="isRequestComplete">
                        <div class="col-md-12">
                            <div class="error-template">
                                <h1>
                                    Oops!</h1>
                                <h2>
                                    403 </h2>
                                <div class="error-details">
                                    Sorry!, You don't have permission to access this page.
                                </div>
                            </div>
                        </div>
                    </template>
                </template>
            </div> 
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import Vue from "vue";
    import Footer from "@/components/partials/Footer";
    import {HTTP} from '../../http-common';
    import {commonMixins} from '../../mixins/commonMixins';
    import moment from 'moment';
    import EventBus from '../event-bus';

    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    Vue.use(VueGoodTable);

    import vSelect from 'vue-select';
    Vue.component('v-select', vSelect);
    // import 'vue-select/dist/vue-select.css';

    Vue.component("app-footer", Footer);
    export default {
        name: 'UserCreate',
        mixins: [commonMixins],
        data () {
            return {
                cantAccessPage: true,
                isRequestComplete: false,
                name: '',
                email: '',
                password: '',
                cpassword: '',
                emp_error_msg: '',
                emp_id: '',
                timezoneArr: [],
                timezoneId: "",
                sectionId: '',
                sectionArr: [],
                roleId: '',
                roleArr: [],
                generateSectionArr: [],
                blockRemoval: true,
                isUpdate: false,
                pType: 'password',
                cType: 'password',
                btnText: 'Register',
                headerText: "Add User",
                changePassword: "",
                chagne_pwd_error_msg: "",
                changeCPassword: "",
                chagne_cpwd_error_msg: "",
                removedArr: [],
                removeSection:'',
                removeRole:''
            }
        },
        mounted: function() {
            var self = this;
            EventBus.$emit("headerMobileView", 'User Create');
            self.loadTimezone();
            self.loadRoles();
            self.loadSection();

            self.isUpdate = false;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3]) {
                self.isUpdate = true;
                self.btnText = 'Update';
                self.headerText = "Update User";
                self.loadUser(segments[3]);
            }
            self.getPermissions();
        },
        watch: {
            generateSectionArr() {
                var self = this;
                self.blockRemoval = self.generateSectionArr.length <= 1
            }
        },
        filters: {
            filterUSting(data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            }
        },
        methods: {
            backToUser: function() {
                var self = this;
                self.$router.push("/user/list/");
            },
            removeLine (lineId, sectionObj, roleObj) {
                var self = this;
                if (lineId == 0) {
                    if (!self.blockRemoval) self.generateSectionArr.splice(lineId, 1)
                } else {
                    self.generateSectionArr.splice(lineId, 1);
                }

                if(sectionObj && roleObj) {
                    // alert(sectionObj.value);
                    // alert(roleObj.value);
                    if(self.generateSectionArr && self.generateSectionArr.length > 0) {
                        for(var i=0;i<self.generateSectionArr.length;i++) {
                            // alert(self.generateSectionArr[i].sectionId.value);
                            // alert(self.generateSectionArr[i].roleId.value);
                            if(self.generateSectionArr[i].sectionId.value == sectionObj.value && self.generateSectionArr[i].roleId.value == roleObj.value) {
                                // self.removeSection += sectionObj.value + ",";
                                // self.removeRole += roleObj.value + ",";
                                continue;
                            } else {
                                self.removeSection += sectionObj.value + ",";
                                self.removeRole += roleObj.value + ",";
                            }
                        }
                    }
                    console.log(self.removeSection);
                }
            },
            addLine () {
                var self = this;
                var index = self.generateSectionArr.length - 1;
                self.generateSectionArr[index].section_error_msg = "";
                self.generateSectionArr[index].role_error_msg = "";

                if (index + 1 < self.sectionArr.length && self.generateSectionArr[index].sectionId != null && self.generateSectionArr[index].roleId) {
                    self.generateSectionArr.push({
                        roleId: null,
                        sectionId: null,
                        section_error_msg: "",
                        role_error_msg: "",
                    })
                } else {
                    if (self.generateSectionArr[index].sectionId == null || !self.generateSectionArr[index].sectionId.value) {
                        self.generateSectionArr[index].section_error_msg = "Section is Required.";
                    }
                    if (self.generateSectionArr[index].roleId == null || !self.generateSectionArr[index].roleId.value) {
                        self.generateSectionArr[index].role_error_msg = "Role is Required.";
                    }
                }
            },
            loadTimezone: function() {
                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                HTTP.get("get-timezone", config)
                    .then(function (data) {
                        if (data.data.code == 200 && data.data.status == 'success') {
                            self.timezoneArr = data.data.content;
                        }
                        if(self.timezoneArr.length > 0) {
                            self.timezoneId = {text: self.timezoneArr[0].text, value: self.timezoneArr[0].value};
                        }
                    })
                    .catch(function (error) {
                        self.catchHandler(error, function () {});
                    })
            },
            loadRoles: function() {
                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                HTTP.get("get-role", config)
                    .then(function (data) {
                        if (data.data.code == 200 && data.data.status == 'success') {
                            for(var i=0;i<data.data.content.length;i++) {
                                if(data.data.content[i].text != 'Guest') {
                                    self.roleArr.push(data.data.content[i]);
                                }
                            }
                        }
                    })
                    .catch(function (error) {
                        self.catchHandler(error, function () {});
                    })
            },
            loadSection: function() {
                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };

                HTTP.get("get-sections", config)
                    .then(function (data) {
                        if (data.data.code == 200 && data.data.status == 'success') {
                            self.sectionArr = data.data.content;
                            self.generateSectionArr = [];

                            var path = window.location.pathname;
                            var segments = path.split("/");
                            if (!segments[3]) {
                                self.generateSectionArr.push({
                                    roleId: null,
                                    sectionId: null,
                                    section_error_msg: "",
                                    role_error_msg: "",
                                });
                            }
                        }
                    })
                    .catch(function (error) {
                        self.catchHandler(error, function () {});
                    })
            },
            getUserDetails: function() {
                var self = this;
                var error = false;
                self.emp_error_msg = "";
                self.email = "";
                self.name = "";

                if(!self.emp_id && self.emp_id == '') {
                    self.emp_error_msg = "Enter Employee Id.";
                    error = true;
                }
                if(!error) {
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                        params: {
                            'emp_id': self.emp_id
                        }
                    };
                    self.showLoader();
                    HTTP.get("get-user-info", config)
                        .then(function (data) {
                            if (data.data.code == 200 && data.data.status == 'success') {
                                self.name = data.data.content.name;
                                self.email = data.data.content.username;
                            }
                            self.hideLoader();
                        })
                        .catch(function (error) {
                            self.hideLoader();
                            error.response.data.message = "Please Enter Valid Deforce Id!";
                            self.catchHandler(error, function () {});
                        })
                }
            },
            createUser: function() {
                var self = this;
                var error = false;
                self.emp_error_msg = '';
                if(!self.emp_id && self.emp_id == '') {
                    self.emp_error_msg = "Enter Employee Id.";
                    error = true;
                } else {
                    this.$validator.validateAll().then((result) => {
                        if (result) {
                            for (var i=0; i<self.generateSectionArr.length; i++) {
                                self.generateSectionArr[i].section_error_msg = "";
                                self.generateSectionArr[i].role_error_msg = "";
                                if (self.generateSectionArr[i].sectionId == null || !self.generateSectionArr[i].sectionId.value) {
                                    self.generateSectionArr[i].section_error_msg = "Section is Required.";
                                    error = true;
                                }
                                if (self.generateSectionArr[i].roleId == null || !self.generateSectionArr[i].roleId.value) {
                                    self.generateSectionArr[i].role_error_msg = "Role is Required.";
                                    error = true;
                                }
                            }
                            if(!error) {
                                var getRoleArr = [];
                                var getSectionArr = [];
                                var path = window.location.pathname;
                                var segments = path.split("/");
                                var apiURL = "craete-user";
                                if(segments[3] && segments[3] > 0) {
                                    apiURL = "update-user";
                                }
                                var rolesData = '';
                                var sectionsData = '';
                                for (var i = 0; i < self.generateSectionArr.length; i++) {
                                    if(
                                        (sectionsData.includes(self.generateSectionArr[i].sectionId.text) 
                                        && rolesData.includes(self.generateSectionArr[i].roleId.text))
                                    ) {
                                    } else {
                                        sectionsData += (self.generateSectionArr[i].sectionId.value) + ',';
                                        rolesData += (self.generateSectionArr[i].roleId.value) + ',';
                                    }
                                }
                                sectionsData = sectionsData.replace(/,\s*$/, "");
                                rolesData = rolesData.replace(/,\s*$/, "");

                                self.removeSection = self.removeSection.replace(/,\s*$/, "");
                                self.removeRole = self.removeRole.replace(/,\s*$/, "");

                                var fields = {
                                    email: self.email,
                                    password: self.password,
                                    emp_id: self.emp_id,
                                    name: self.name,
                                    sections: sectionsData,
                                    roles: rolesData,
                                    timezone: self.timezoneId.value,
                                    device_type: null,
                                    device_token: null,
                                    id: segments[3],
                                    removedSections: self.removeSection,
                                    removedRoles: self.removeRole
                                };
                                var config = {
                                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                                };
                                self.showLoader();
                                HTTP.post(apiURL, fields, config)
                                    .then(function (data) {

                                        if (data.data.status == 'success') {
                                            if(segments[3] && segments[3] > 0) {
                                                if(data.data.display_message != '') {
                                                    // alert("Hello");
                                                    self.$swal({
                                                        // title: 'Success',
                                                        text: data.data.display_message,
                                                        type: 'info',
                                                        confirmButtonText: 'Ok',
                                                        showLoaderOnConfirm: true
                                                    })
                                                } else {
                                                    self.$router.push("/user/list/");        
                                                }
                                            } else {
                                                if(data.data.code == 200) {
                                                    self.$router.push("/user/list/");
                                                } else {
                                                    self.$swal({
                                                        // title: 'Success',
                                                        text: data.data.message,
                                                        type: 'info',
                                                        confirmButtonText: 'Ok',
                                                        showLoaderOnConfirm: true
                                                    })
                                                }
                                            }
                                        }
                                        self.hideLoader();
                                    })
                                    .catch(function (error) {
                                        self.hideLoader();
                                        //console.log(error);
                                        self.catchHandler(error, function () {});
                                    })
                            }
                        }
                    });
                }
            },
            loadUser: function(id) {
                var self = this;
                var fields = {
                    'user_id': id
                }
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                self.showLoader();
                HTTP.post("get-user-by-id", fields, config)
                    .then(function (response) {
                        if (response.data.code == '200') {
                            if (response.data.status == "success") {
                                self.emp_id = (response.data.content.emp_id != null) ? response.data.content.emp_id : '';
                                self.email = response.data.content.username;
                                self.name = response.data.content.name;
                                setTimeout(function() {
                                    self.timezoneId = "";
                                    if(response.data.content.timezone_id != null) {
                                        self.timezoneId = {text: response.data.content.tzName, value: response.data.content.timezone_id};
                                    } else {
                                        if(self.timezoneArr.length > 0) {
                                            self.timezoneId = {text: self.timezoneArr[0].text, value: self.timezoneArr[0].value};
                                        }
                                    }
                                }, 50);
                                self.generateSectionArr = [];
                                if(response.data.userRoleSection && response.data.userRoleSection.length > 0) {
                                    setTimeout(function() {
                                        $.each(response.data.userRoleSection, function(index) {
                                            var model = response.data.userRoleSection[index];
                                            self.generateSectionArr.push({
                                                roleId: {text: model.role, value: model.roleId},
                                                sectionId: {text: model.sections, value: model.sectionId},
                                                section_error_msg: "",
                                                role_error_msg: "",
                                            });
                                        });
                                    },500);
                                } else {
                                    self.generateSectionArr.push({
                                        roleId: null,
                                        sectionId: null,
                                        section_error_msg: "",
                                        role_error_msg: "",
                                    });
                                }
                            }
                        }
                        self.hideLoader();
                    })
                    .catch(function (err) {
                        self.hideLoader();
                        self.catchHandler(error, function () {});
                    });
            },
            chagnePasswrodAPI: function() {
                var self = this;
                self.chagne_pwd_error_msg = "";
                self.chagne_cpwd_error_msg = "";
                var error = false;

                if(self.changePassword == "" || !self.changePassword || self.changePassword == null ) {
                    self.chagne_pwd_error_msg = "The Password field is required.";
                    error = true;
                }
                if(self.changePassword && (self.changePassword.length < 6)) {
                    self.chagne_pwd_error_msg = "The Password field must be at least 6 characters.";
                    error = true;
                }
                if(self.changeCPassword == "" || !self.changeCPassword || self.changeCPassword == null) {
                    self.chagne_cpwd_error_msg = "The Confirm Password field is required.";
                    error = true;
                }
                if(self.changePassword && (self.changePassword != self.changeCPassword)) {
                    self.chagne_cpwd_error_msg = "The Confirm Password confirmation does not match.";
                    error = true;
                }

                if(!error) {
                    var fields = {
                        email: self.email,
                        password: self.changePassword,
                    };
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    };
                    // self.showLoader();
                    HTTP.post("change-password", fields, config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                $("#password").modal('hide');
                                self.$swal({
                                    title: 'Success',
                                    text: "Password reset Successfully.",
                                    type: 'success',
                                    confirmButtonText: 'Ok',
                                    showLoaderOnConfirm: true
                                });
                            }
                            // self.hideLoader();
                        })
                        .catch(function (error) {
                            $("#password").modal('hide');
                            // self.hideLoader();
                            console.log(error);
                            self.catchHandler(error, function () {});
                        });
                }
            },
            changePasswordModalClose: function() {
                /* $('#password')[0].hidden = true;
                $('.modal-backdrop').remove();
                self.$nextTick(() => {
                    $('body').removeClass('modal-open');
                }); */
                $("#password").modal('hide');
            },
            hideShow: function() {
                var self = this;
                self.pType = (self.pType == 'password') ? 'text' : 'password';
            },
            hideShowCPass: function() {
                var self = this;
                self.cType = (self.cType == 'password') ? 'text' : 'password';
            }
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->


// WEBPACK FOOTER //
// src/components/Users/UserCreate.vue